import React, { useState } from 'react'
import { Grid, Modal } from '@material-ui/core/'
import { Button } from 'components/UI/'
import infoIcon from '../../../../../../../assetss/img/infoIcon.svg'
import closeIcon from '../../../../../../../assetss/img/closeModalIcon.svg'
import './index.scss'

const AcceptKeepCaht = ({ open, setOpen, deleteChat }) => (
  <Modal
    open={open}
    onClose={setOpen}
  >
    <div className='acceptKeepChat'>
      <div className='boxKeepModal'>
        <img src={closeIcon} className='iconClose' onClick={setOpen} />
        <div className='textKeep'>Are you sure? You cannot undo this action.</div>
        <Button
          className='keepBtnChat'
          onClick={() => {
            deleteChat()
            setOpen()
          }}
        >
          Delete chat
        </Button>
      </div>
    </div>
  </Modal>
)

const KeepChat = ({ name, keepChat, deleteChat, keep }) => {
  const [open, setOpen] = useState(false)
  return (
    open ? (
      <AcceptKeepCaht open={open} setOpen={() => setOpen(false)} deleteChat={deleteChat} />
    ) : (
      <Grid className='keeChatUserWrapper'>
        <Grid className='keeChatWrapper'>
          <img className='infoIcon' src={infoIcon} alt='infoIcon' />
          <Grid className='keepChatBox'>
            <Grid className='textKeepChat'>
              Would you like to keep chatting with {name}? Otherwise, the chat will be deleted within 24 hours.
            </Grid>
            <Grid className='btnContainer'>
              <Button onClick={keepChat} className='btnAccept'>Keep chatting</Button>
              <Button onClick={() => setOpen(true)} className='btnDecline'>Delete chat</Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  )
}

export default KeepChat
